import React from 'react';
import { SpacingCustom } from '../../../layout/Spacing/SpacingCustom';
import { ConflictCategory } from './ConflictCategory/ConflictCategory';
import { CONFLICT_INSPECTOR_BUTTONS } from '../../../../constants/constants';
import { DatamanagerFeatures } from './Datamanager/DatamanagerFeatures';
import { Details } from './Details/Details';
import { AIAnalyzer } from './AiAnalyzer/Analyzer/AiAnalyzer';
import { useTabButtons } from '../../../../hooks/useTabButtons';

interface IInspectorProps {
    socketRef: React.MutableRefObject<WebSocket | null>
}

export const Inspector: React.FC<IInspectorProps> = ({socketRef}) => {
    const {tabButtons, activeBtn} = useTabButtons(CONFLICT_INSPECTOR_BUTTONS);


    return (
            <div style={{ position: 'relative' }}>
                <SpacingCustom paddingTop={0.5} paddingLeft={0.5} paddingRight={0.5} paddingBottom={0.5}>
                    <SpacingCustom paddingBottom={0.5} paddingRight={0}>
                        {tabButtons}
                    </SpacingCustom>

                    <div style={{ height: '100%' }}>
                        <SpacingCustom stretch paddingTop={1} paddingLeft={0} paddingRight={0} paddingBottom={1}>
                            {activeBtn === 'Category' && <ConflictCategory />}
                            {activeBtn === 'Datamanager' && <DatamanagerFeatures socketRef={socketRef} />}
                            {activeBtn === 'Details' && <Details />}
                            {activeBtn === 'Neuland_AI' && <AIAnalyzer />}
                        </SpacingCustom>
                    </div>
                </SpacingCustom>
            </div>
    );
};
